module.exports = __webpack_public_path__ + "static/media/scheduled-practice.c5cb99c3.svg";